import React from 'react';
import {Icon} from '@atoms';
import {PersonLike} from '@lib/infrastructure';
import {Group, GroupWithWorkdayCount, useAppSelector} from '@lib/store';
import {GroupAvatar} from '@molecules';

export const AddGroupMembersSectionItem = ({
  onSelect,
  group,
}: {
  onSelect: (invitees: PersonLike[], groupId: string) => void;
  group: GroupWithWorkdayCount;
}) => {
  const currentUserId = useAppSelector((state) => state.data.user.user.id);

  const handleAdd = () => {
    onSelect(
      group.members
        .filter((member) => member.status === 'Accepted' && member.user.id !== currentUserId)
        .map(({user}) => user),
      group.id,
    );
  };

  return (
    <button
      key={group.id}
      onClick={handleAdd}
      className="grid grid-cols-[auto_1fr_auto] gap-x-4 items-center w-full py-2 text-left hover:bg-mapiq-black-50 transition-colors">
      <GroupAvatar
        size="medium"
        group={group}
        className="shadow-mapiq-small flex-shrink-0"
      />

      <p className="text-mapiq-black-800 truncate">{group.name}</p>

      <Icon
        icon="plus"
        color="currentColor"
        className="ml-auto self-center size-5 text-mapiq-black-500"
      />
    </button>
  );
};
